"use client";

import Image from "next/image";
import Link from "next/link";
import { FiInstagram } from "react-icons/fi";

import { INSTAGRAM_LINK } from "@/constants/links";
import { logEvent } from "@/services/firebase";
import { GenericSection } from "./ui";

interface ISocialMediaPhoto {
  src: string;
  alt: string;
}

const socialMediaPhotos: ISocialMediaPhoto[] = [
  {
    src: "/images/instagram-1.png",
    alt: "Foto do Instagram 1",
  },
  {
    src: "/images/instagram-2.png",
    alt: "Foto do Instagram 2",
  },
  {
    src: "/images/instagram-3.png",
    alt: "Foto do Instagram 3",
  },
];

export const SocialMedia = () => {
  return (
    <GenericSection
      id="social-media"
      heading="Redes Sociais"
      subheading="Me siga no Instagram para ver mais"
      icon={
        <Link
          href={INSTAGRAM_LINK}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visitar meu perfil no Instagram"
          className="inline-flex items-center justify-center"
          onClick={() =>
            logEvent("instagram_click", { section: "social-media" })
          }
        >
          <FiInstagram
            size={32}
            className="text-primary mt-3"
            aria-hidden="true"
          />
        </Link>
      }
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {socialMediaPhotos.map((photo, index) => (
          <div
            key={index}
            className="relative rounded-lg overflow-hidden bg-gray-100 w-full"
          >
            <Link
              href={INSTAGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Veja no Instagram: ${photo.alt}`}
              className="block"
            >
              <Image
                src={photo.src}
                alt={photo.alt}
                width={500}
                height={500}
                objectFit="cover"
                className="rounded-lg h-96 w-96 object-cover"
              />
            </Link>
          </div>
        ))}
      </div>
    </GenericSection>
  );
};
